import {CustomersCustomerAccounts} from "./CustomersCustomerAccounts";
import {AuthorizationProvider} from "@infonova/framework/lib/security/AuthorizationProvider";
import { CustomerAccount } from "../types/CustomerAccount";
import { CustomerV1DomainRelationshipList } from "src/app/api/infonova/models/CustomerV1DomainRelationshipList";
import { PartyOrganization } from "../types/PartyOrganization";
import { CustomerV1AccountList } from "../types/CustomerAccountsList";
import { Pagination } from "../types/Pagination";

/**
 * Example implementation for accessing an API.
 */
export class CustomersCustomerAccountsImpl implements CustomersCustomerAccounts {

    private r6ApiBaseUrl: string;
    private customerAccountListUrl: string;
    private v1url: string;
    private v2url: string;

    constructor(r6ApiBaseUrl: string, private authorizationProvider: AuthorizationProvider) {
        this.r6ApiBaseUrl = r6ApiBaseUrl;
        this.customerAccountListUrl = r6ApiBaseUrl + "/customers/v1/customerAccounts";
        this.v1url = r6ApiBaseUrl + "/customers/v1/customerAccounts/{id}";
        this.v2url = r6ApiBaseUrl + "/customers/v2/customerAccounts/{id}";
    }

    async getCustomerAccount(id: string): Promise<CustomerAccount> {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();
        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }

        const url = this.v2url.replace('{id}', id);
        return fetch(url, {
            method: 'GET',
            headers
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });

    }

    async getCustomerAccounts(pagination?: Pagination): Promise<CustomerV1AccountList> {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();
        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }


        const paginationStr = pagination ? `&page=${pagination.page}&pageSize=${pagination.pageSize}` : '';
        return fetch(this.customerAccountListUrl + `?query=state:Active&sortBy=id&sortOrder=desc${paginationStr}`, {
            method: 'GET',
            headers
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });
    }

    async getCustomerAccountRelationships(id: string): Promise<CustomerV1DomainRelationshipList> {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();
        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }
        const url = (this.v1url + "/relationships").replace('{id}', id);
        return fetch(url, {
            method: 'GET',
            headers
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });
    }

    async getPartyOrganization(id: string): Promise<PartyOrganization> {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();
        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }
        const url = (this.r6ApiBaseUrl + "/parties/v1/organizations/{id}").replace('{id}', id);
        return fetch(url, {
            method: 'GET',
            headers
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });
    }
}
